// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row_Gx3te {
    width: 100%;
    gap: 8px !important;
    padding-right: 16px;
}

.label_HgGtF {
    flex: 1 1 auto; /* Allow it to shrink but not grow */
}

.value_xbGaE {
    flex: 0 0 auto; /* Disable shrinking and growing for fixed-size children */
}

.title_TVqEU {
    font-size: 15px !important;
    font-weight: 600 !important;
    line-height: 20px !important;
    letter-spacing: 0em !important;
    color: var( --color-base700) !important;
}

.subtitle_NTWW8 {
    font-size: 12px !important;
    font-weight: 700 !important;
    line-height: 20px !important;
    letter-spacing: 0em !important;
    color: var( --color-base700) !important;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/recovrGeneric/details/refreshLocationCache/RefreshLocationCacheDetailRenderer.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc,EAAE,oCAAoC;AACxD;;AAEA;IACI,cAAc,EAAE,0DAA0D;AAC9E;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;IAC9B,uCAAuC;AAC3C;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;IAC9B,uCAAuC;AAC3C","sourcesContent":[".row {\n    width: 100%;\n    gap: 8px !important;\n    padding-right: 16px;\n}\n\n.label {\n    flex: 1 1 auto; /* Allow it to shrink but not grow */\n}\n\n.value {\n    flex: 0 0 auto; /* Disable shrinking and growing for fixed-size children */\n}\n\n.title {\n    font-size: 15px !important;\n    font-weight: 600 !important;\n    line-height: 20px !important;\n    letter-spacing: 0em !important;\n    color: var( --color-base700) !important;\n}\n\n.subtitle {\n    font-size: 12px !important;\n    font-weight: 700 !important;\n    line-height: 20px !important;\n    letter-spacing: 0em !important;\n    color: var( --color-base700) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `row_Gx3te`,
	"label": `label_HgGtF`,
	"value": `value_xbGaE`,
	"title": `title_TVqEU`,
	"subtitle": `subtitle_NTWW8`
};
export default ___CSS_LOADER_EXPORT___;
